import { LucideIcon, Settings, Home, CalendarCheck2} from 'lucide-react'

export const SIDENAV_ITEMS: SidenavItems[] = [
    {
        id: 10,
        label: 'Inicio',
        Icon: Home ,
        to: '/'
    },
    {
        id: 15,
        label: 'Processo Hub',
        Icon: CalendarCheck2 ,
        subItems: [
            {
                id: 15.10,
                label: 'Conferência Hub',
                to: '/processhub/conferencehub'
            },
            {
                id: 15.20,
                label: 'Parâmetros Conf. Hub',
                to: '/processhub/parameter/conferencehub'
            },
        ]
    },
    {
        id: 20,
        label: 'Dados Mestre',
        Icon: Settings,
        subItems: [
            {
                id: 20.10,
                label: 'Empresa',
                to: '/masterdata/companies'
            },
            {
                id: 20.20,
                label: 'Fornecedor',
                to: '/masterdata/supplier'
            },
            {
                id: 20.30,
                label: 'Impeditivos',
                to: '/masterdata/impediment'
            },
            {
                id: 20.40,
                label: 'Operações',
                to: '/masterdata/operation'
            },
            {
                id: 20.50,
                label: 'Transportadora',
                to: '/masterdata/carrier'
            },
        ]
    },
    
]

export type SidenavItems = {
    id: number
    label: string
    to?: string
    Icon?: LucideIcon
    subItems?: SidenavItems[]
}
